<template>
	<form @submit.prevent="submit" class="omapi-search flex">
		<input
			type="search"
			class="omapi-input omapi-input__inline"
			v-model="internalSearchTerm"
			@keydown.esc="clear"
			@search="submit"
			v-bind="$attrs"
		/>
		<core-button buttonType="submit" :size="size">Search</core-button>
	</form>
</template>

<script>
export default {
	props : {
		searchTerm : String,
		size       : {
			default : 'large',
			type    : String,
		},
	},
	data () {
		return {
			internalSearchTerm : this.searchTerm,
		}
	},
	watch : {
		searchTerm (val) {
			this.internalSearchTerm = val
		},
	},
	methods : {
		clear () {
			this.internalSearchTerm = ''
			this.submit()
		},
		submit () {
			this.$emit('searched', this.internalSearchTerm)
		},
	},
}
</script>

<style lang="scss">
	.omapi-screen .omapi-subscribers-page {
		.omapi-search {
			align-items: center;
			input[type=search] {
				flex: 1;
				margin-bottom: 0;
				height: 30px;
			}
			button[type=submit] {
				padding: 6px 12px;
			}
		}
	}
</style>
